import { Fragment, useMemo } from 'react';
import { Layouts } from '~/shared';
import { ExchangeState, rage, useObservable } from '~/rage';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { useLayoutSelector } from '../../redux';
import { StyledBackground, StyledContainer } from './Background.styled';

const Background: React.FC = () => {
	const exchangeState = useObservable(rage.exchange.getExchangeState());
	const waitingForInvite = useLayoutSelector(
		(state) => state.propertyExchange.waitingForInvite,
	);

	const opacity = useMemo(() => {
		if (!waitingForInvite) {
			if (exchangeState === ExchangeState.Completed) {
				return 0.9;
			}
			return 0.98;
		}

		return 0.85;
	}, [waitingForInvite, exchangeState]);

	return (
		<Fragment>
			{rage.config.isStub() && (
				<BgPlaceholder $type={PlaceholderType.Default} />
			)}
			<StyledContainer className={`${Layouts.PropertyExchange}-background`}>
				<StyledBackground style={{ opacity }} />
			</StyledContainer>
		</Fragment>
	);
};

export { Background };
